import defaultTranslations from "/WebInterface/new-ui/modules/localizations/language/default.en.js";

let translations = {};
let locale = "";

const interpolate = (message, interpolations) => {
  return Object.keys(interpolations).reduce((interpolated, key) => {
    return interpolated.replace(
      new RegExp(`{\\s*${key}\\s*}`, "g"),
      interpolations[key]
    );
  }, message);
};

const translate = (key, interpolations = {}, defVal) => {
  const value = translations[key] || defaultTranslations[key] || defVal;
  return value ? interpolate(value, interpolations) : defVal || key;
};

const translateElement = (element) => {
  const key = element.getAttribute("data-i18n-key");
  const options = JSON.parse(element.getAttribute("data-i18n-opt")) || {};
  const attrToUpdate =
    element.getAttribute("data-i18n-attr-to-update") || "innerText";
  const defValue = element.getAttribute("data-i18n-defaultValue");

  element[attrToUpdate] = "";
  element[attrToUpdate] = translate(key, options, defValue);
};

const translatePage = () => {
  const elements = document.querySelectorAll("[data-i18n-key]");
  elements.forEach(translateElement);
};

export const t = (key, interpolations = {}, defVal) => {
  const value = translations[key] || defaultTranslations[key] || defVal;
  return value ? interpolate(value, interpolations) : defVal || key;
};

const setLocale = async ({ newLocale, newTranslations }) => {
  if (newLocale === locale) return;

  document.documentElement.lang = newLocale;

  locale = newLocale;
  translations = newTranslations;
  translatePage();
};

export default setLocale;
